import { createContext, useContext } from 'react';

interface TrackingDetailsProviderProps {
  children: React.ReactNode;
  value: TrackingDetails;
}

export interface TrackingDetails {
  defaultLanguage: string;
  journey: string;
  productTitle: string;
  stage: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const TrackingDetailsContext = createContext<
  TrackingDetails | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useTrackingDetails = () => {
  const context = useContext(TrackingDetailsContext);

  if (context === undefined) {
    throw new Error(
      `@zeiss/lib-components: tracking details are not set. Use TrackingDetailsProvider to set one.
      `,
    );
  }

  return context;
};

/**
 * Context provider to set up journey and product details for lib-components and apps.
 *
 */
export const TrackingDetailsProvider = ({
  children,
  value,
}: TrackingDetailsProviderProps) => {
  return (
    <TrackingDetailsContext.Provider value={value}>
      {children}
    </TrackingDetailsContext.Provider>
  );
};
